export const EVENTS = {
    CHANGE: 'change',
};
